export default __webpack_public_path__ + "static/img2@2x-c2ce748c166d8f109bf33861e4f6df4d.jpg";